export const formatAgo = (date: string) => {
    const now = new Date();
    const then = new Date(date);
    const diff = now.getTime() - then.getTime();

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    // C'est une dinguerie de devoir faire ça....
    if (years > 0) {
        return `Il y a ${years} ${years === 1 ? 'an' : 'ans'}`;
    } else if (months > 0) {
        return `Il y a ${months} ${months === 1 ? 'mois' : 'mois'}`;
    } else if (days > 0) {
        return `Il y a ${days} ${days === 1 ? 'jour' : 'jours'}`;
    } else if (hours > 0) {
        return `Il y a ${hours} ${hours === 1 ? 'heure' : 'heures'}`;
    } else {
        return `Il y a ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
    }
};

export const formatDate = (date: string) => {
    const dateObject = new Date(date);
    return dateObject.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};
